// extracted by mini-css-extract-plugin
export default {"snowflakes":"Snowflakes_snowflakes__DV25U"};